<template>
<thead>
  <tr>
    <th class="align-top" scope="col" id="th-selection">
      <a href="#" title="Select all" @click.prevent="selectAll">
        <font-awesome-icon icon="check-square" />
      </a>
      <a href="#" class="ml-2" title="Deselect all" @click.prevent="deselectAll">
        <font-awesome-icon :icon="['far', 'square']" />
      </a>
    </th>
    <th class="align-top" scope="col" v-for="(column, columnIndex) in searchForm.columns" v-bind:key="columnIndex" v-show="column.visible">
      <a href="#" @click.prevent="sort(column.key)" v-html="column.label" />
      <a href="#" @click.prevent="addOrReverseSort(column.key)" v-if="sortIcons[columnIndex] !== null">
        <font-awesome-icon :icon="sortIcons[columnIndex]" />
      </a>
    </th>
  </tr>
</thead>
</template>

<script>
import {
  mapState
} from 'vuex';

export default {
  name: 'ResultTableThead',
  computed: mapState({
    searchForm: state => state.searchForm,
    sortIcons: state => {
      let sortingSequence = state.searchForm.sortingSequence;
      let columns = state.searchForm.columns;
      let icons = [];
      for (let i = 0; i < columns.length; i++) {
        let icon = null;
        for (let j = 0; j < sortingSequence.length; j++) {
          if (columns[i].key === sortingSequence[j].columnName) {
            if (sortingSequence[j].sort === 'ASC') {
              icon = 'arrow-up';
            } else {
              icon = 'arrow-down';
            }
          }
        }
        if (sortingSequence.length > 0 && icon === null) {
          icon = 'plus';
        }
        icons.push(icon);
      }
      return icons;
    }
  }),
  methods: {
    selectAll() {
      this.selectInputs(true);
    },
    deselectAll() {
      this.selectInputs(false);
    },
    selectInputs(value) {
      document.querySelectorAll('#result-table input').forEach(input => input.checked = value);
    },
    sort(columnKey) {
      this.$store.dispatch("sort", columnKey);
    },
    addOrReverseSort(columnKey) {
      this.$store.dispatch("addOrReverseSort", columnKey);
    }
  }
};
</script>
